/**
 * API client for Centre Audit > Centre Audit and HK.
 *
 * Backend: oh_operations/api/alfred_centre_audits.py. Each list call also returns
 * the questions, so the page follows the backend's list. Every `apiEndpoints.X`
 * reference lives INSIDE a function body (TDZ-safety — mirrors lifeCatchUps.js).
 */
import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { get, patch, post } from '../request'

const fetchVisitAudits = async (kind) => {
  try {
    const response = await get(`${apiEndpoints[kind]}/alfred`)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching visit audits')
    throw error
  }
}

const fetchAuditForm = async (kind, centre) => {
  try {
    const response = await get(`${apiEndpoints[kind]}/form/${centre}/alfred`)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching audit form')
    throw error
  }
}

const submitAuditForm = async (kind, centre, payload) => {
  try {
    const response = await post(
      `${apiEndpoints[kind]}/form/${centre}/alfred`,
      payload
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in filing audit')
    throw error
  }
}

const updateVisitAudit = async (kind, uuid, payload) => {
  try {
    const response = await patch(
      `${apiEndpoints[kind]}/${uuid}/alfred`,
      payload
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in updating visit audit')
    throw error
  }
}

export { fetchVisitAudits, fetchAuditForm, submitAuditForm, updateVisitAudit }
